"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.____PointerRanges = exports.____PointerRange = exports.____Pointer = exports.____PF = exports.isRelPos = exports.RelPos = void 0;
const __1 = require("..");
const parentheses_1 = require("./parentheses");
var RelPos;
(function (RelPos) {
    RelPos["PREV"] = "PREV";
    RelPos["HERE"] = "HERE";
    RelPos["NEXT"] = "NEXT";
    RelPos["SAME"] = "SAME";
    RelPos["NAMED"] = "NAMED";
    RelPos["EACH"] = "EACH";
})(RelPos || (exports.RelPos = RelPos = {}));
const isRelPos = (object) => {
    return (object === RelPos.PREV ||
        object === RelPos.HERE ||
        object === RelPos.NEXT ||
        object === RelPos.NAMED);
};
exports.isRelPos = isRelPos;
class ____PF extends __1.EL {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    tag = "____PF";
    get isControl() { return true; }
    attr;
    children;
    constructor(options) {
        super("____PF", {}, [], options.range);
        const { relPos, targetType, name, num = null, count = null, } = {
            ...options,
        };
        this.attr = {
            relPos,
            targetType: targetType,
            name,
        };
        if (num !== null)
            this.attr.num = num;
        if (count !== null)
            this.attr.count = count;
        this.children = [name];
    }
}
exports.____PF = ____PF;
class ____Pointer extends __1.EL {
    tag = "____Pointer";
    get isControl() { return true; }
    children;
    constructor(options) {
        super("____Pointer", {}, [], options.range);
        this.children = options.children;
    }
    fragments() {
        return this.children.filter(c => c instanceof ____PF);
    }
}
exports.____Pointer = ____Pointer;
class ____PointerRange extends __1.EL {
    tag = "____PointerRange";
    get isControl() { return true; }
    children;
    constructor(options) {
        super("____PointerRange", {}, [], options.range);
        this.children = [
            options.from,
            ...options.midChildren,
            ...(options.to ? [options.to] : []),
            ...options.trailingChildren,
        ];
    }
    pointers() {
        return this.children.filter(c => c instanceof ____Pointer);
    }
    modifierParentheses() {
        const lastChild = this.children[this.children.length - 1];
        if (lastChild instanceof parentheses_1.__Parentheses) {
            return lastChild;
        }
        else {
            return null;
        }
    }
}
exports.____PointerRange = ____PointerRange;
class ____PointerRanges extends __1.EL {
    tag = "____PointerRanges";
    get isControl() { return true; }
    attr;
    children;
    targetContainerIDRangesCache = null;
    get targetContainerIDRanges() {
        if (this.targetContainerIDRangesCache !== null && this.targetContainerIDRangesCache[0] === this.attr.targetContainerIDRanges) {
            return this.targetContainerIDRangesCache[1];
        }
        else {
            if (!this.attr.targetContainerIDRanges)
                return [];
            const value = JSON.parse(this.attr.targetContainerIDRanges);
            this.targetContainerIDRangesCache = [this.attr.targetContainerIDRanges, value];
            return value;
        }
    }
    set targetContainerIDRanges(value) {
        this.attr.targetContainerIDRanges = JSON.stringify(value);
        this.targetContainerIDRangesCache = [this.attr.targetContainerIDRanges, value];
    }
    constructor(options) {
        super("____PointerRanges", {}, [], options.range);
        this.children = options.children;
        this.attr = {};
    }
    ranges() {
        return this.children.filter(c => c instanceof ____PointerRange);
    }
}
exports.____PointerRanges = ____PointerRanges;
//# sourceMappingURL=pointer.js.map